/**
 * Converts a message body that may contain HTML markup into clean plain text
 * suitable for short, truncated previews (e.g. activity feeds, overview cards).
 *
 * Unlike the full message view, previews should not render rich HTML — they
 * are single- or two-line snippets. This strips all tags and decodes entities,
 * collapsing whitespace so leftover block-level gaps don't bloat the preview.
 *
 * Plain-text bodies (no HTML) pass through unchanged apart from whitespace
 * normalisation.
 */
export function htmlToPreviewText(body: string): string {
	// Insert whitespace at block-level and line-break boundaries so adjacent
	// blocks (e.g. "<p>A</p><p>B</p>") don't collapse into "AB" once tags are
	// stripped. The remaining inline tags are removed and entities decoded via
	// textContent below.
	const spaced = body.replace(/<br\s*\/?>/gi, ' ').replace(/<\/(p|div|h[1-6]|li|tr|blockquote|pre|td|th)>/gi, ' ');
	const doc = new DOMParser().parseFromString(spaced, 'text/html');
	const text = doc.body.textContent ?? '';
	return text.replace(/\s+/g, ' ').trim();
}
